import { h } from '@debbie/cortex/dist/index.js';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import Errors from './Errors.js';
import { ArrowLeft, ArrowRight, } from './Icons/index.js';
import PowerView from './power-table/View.js';
const useOptionalUrlState = (initial, key) => {
    const useUrl = key != null && key != '';
    let [state, setState] = useState(initial);
    const history = useHistory();
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const paramState = params.get(key ?? '');
    const urlState = paramState != null ? JSON.parse(paramState) : initial;
    const setUrlState = (f) => {
        if (key != null && key != '') {
            // @ts-expect-error T is not allowed to be function
            const state = typeof f === 'function' ? f(urlState) : f;
            params.set(key, JSON.stringify(state));
            history.replace({ search: params.toString() });
        }
    };
    useEffect(() => {
        if (useUrl && params.get(key) == null) {
            setUrlState(initial);
        }
    }, [params]);
    return useUrl
        ? [urlState, setUrlState]
        : [state, setState];
};
const RemoteTable = (props) => {
    // TODO: Handle multiple tables on one page
    const [filters, setFilters] = useOptionalUrlState(props.initFilters, props.searchParams);
    const [page, setPage] = useState(0);
    const sFilters = (s) => {
        if (typeof s === 'function') {
            setFilters((prev) => {
                const newState = s(prev);
                if (newState != null && props.onFilterChange) {
                    props.onFilterChange(newState);
                }
                return newState;
            });
            return;
        }
        setFilters(s);
        if (props.onFilterChange) {
            props.onFilterChange(s);
        }
    };
    const [sortKey, setSortKey] = useState(
    // @ts-expect-error
    filters[props.sortKeyKey] ?? undefined);
    const [sortDirection, setSortDirection] = useState(
    // @ts-expect-error
    filters[props.sortDirectionKey] ?? 'ASC');
    const loader = props.useFetch(filters, page, props.pageSize);
    const updateFilter = (dispatch) => {
        sFilters(dispatch);
        if (props.onFilterChange) {
            props.onFilterChange;
        }
        setPage(0);
    };
    // Use a ref to track the latest sortKey for the combined filter update
    const sortKeyRef = React.useRef(sortKey);
    const updateSortKey = (key) => {
        setSortKey(key);
        sortKeyRef.current = key;
        // If clearing the sort key, update filters immediately to reset to default sorting
        if (key === undefined) {
            sFilters((f) => ({
                ...f,
                [props.sortKeyKey]: undefined,
                [props.sortDirectionKey]: undefined,
            }));
        }
    };
    const updateSortDirection = (direction) => {
        setSortDirection(direction);
        // Update both sortKey and sortDirection together to avoid race conditions
        sFilters((f) => ({
            ...f,
            [props.sortKeyKey]: sortKeyRef.current,
            [props.sortDirectionKey]: direction,
        }));
    };
    const [inpPage, setInpPage] = useState('0');
    useEffect(() => {
        setInpPage(`${page + 1}`);
    }, [page]);
    return (React.createElement("div", null,
        h.isError(loader) ? React.createElement(Errors, { errors: [loader.error.message] }) : null,
        React.createElement(PaginationWrapper, { top: true },
            React.createElement(PaginationButton, { onClick: () => {
                    setPage(Math.max(0, page - 1));
                } },
                React.createElement(ArrowLeft, null)),
            React.createElement(Inp, { value: inpPage, onChange: (e) => {
                    const inputValue = e.currentTarget.value;
                    if (/^\d*$/.test(inputValue) && inputValue !== '0') {
                        setInpPage(inputValue);
                        const val = parseInt(inputValue);
                        if (!Number.isNaN(val)) {
                            setPage(Math.max(0, val - 1));
                        }
                    }
                } }),
            React.createElement(PaginationButton, { onClick: () => {
                    setPage(page + 1);
                } },
                React.createElement(ArrowRight, null))),
        props.selectable ? (React.createElement(PowerView, { selectable: props.selectable, selected: props.selected, onSelect: props.onSelect, selectKey: props.selectKey, filter: filters, setFilter: updateFilter, initFilter: props.initFilters, loading: h.isLoading(loader) || h.isReloading(loader), genKey: props.genKey, data: h.hasData(loader) ? loader.data.items : [], sortKey: sortKey, onClick: props.onClick, updateSortKey: (key) => updateSortKey(key), direction: sortDirection, updateSortDirection: (dir) => updateSortDirection(dir), emptyComponent: props.emptyComponent, empty: page === 0 && h.hasData(loader)
                ? loader.data.items.length === 0
                : false, dataLoaded: h.hasData(loader), values: props.values })) : (React.createElement(PowerView, { filter: filters, setFilter: updateFilter, initFilter: props.initFilters, loading: h.isLoading(loader) || h.isReloading(loader), genKey: props.genKey, data: h.hasData(loader) ? loader.data.items : [], sortKey: sortKey, onClick: props.onClick, updateSortKey: (key) => updateSortKey(key), direction: sortDirection, updateSortDirection: (dir) => updateSortDirection(dir), emptyComponent: props.emptyComponent, empty: page === 0 && h.hasData(loader)
                ? loader.data.items.length === 0
                : false, dataLoaded: h.hasData(loader), values: props.values })),
        React.createElement(PaginationWrapper, { top: false },
            React.createElement(PaginationButton, { onClick: () => {
                    setPage(Math.max(0, page - 1));
                } },
                React.createElement(ArrowLeft, null)),
            React.createElement(Inp, { value: inpPage, onChange: (e) => {
                    const inputValue = e.currentTarget.value;
                    if (/^\d*$/.test(inputValue) && inputValue !== '0') {
                        setInpPage(inputValue);
                        const val = parseInt(inputValue);
                        if (!Number.isNaN(val)) {
                            setPage(Math.max(0, val - 1));
                        }
                    }
                } }),
            React.createElement(PaginationButton, { onClick: () => {
                    setPage(page + 1);
                } },
                React.createElement(ArrowRight, null)))));
};
const Pagination = styled.div `
  padding: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
  flex-direction: ${(p) => (p.type === 'pages' ? 'row' : 'column')};
`;
const PaginationWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid
    ${(props) => (props.top ? THEME.BORDER_STRONG : THEME.BORDER)};
  color: ${THEME.COLOR_PRIMARY};
`;
const PaginationButton = styled.button `
  background: none;
  color: inherit;
  border: none;
  padding: 0.5em;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  color: ${THEME.COLOR_PRIMARY};
`;
const Inp = styled.input `
  border: none;
  background-image: none;
  background-color: transparent;
  box-shadow: none;
  text-align: center;
  width: 60px;
`;
export default RemoteTable;
//# sourceMappingURL=RemoteTable.js.map